<script setup lang="ts">
import { format, isValid } from "date-fns";

interface Props {
    isExpired: boolean;
    expiryDate?: Date | null;
    responsiveClasses?: string;
}

const props = defineProps<Props>();

const baseClasses = "text-center expire text-secondary expire";

const isValidExpiryDate = (date?: Date | null): date is Date => {
    return date instanceof Date && isValid(date);
};
</script>

<template>
    <div
        v-if="props.isExpired"
        :class="`${baseClasses} ${props.responsiveClasses || ''}`"
    >
        Quote expired - Please click the button above to refresh all your quotes.
    </div>
    <div
        v-else-if="isValidExpiryDate(props.expiryDate) "
        :class="`${baseClasses} ${props.responsiveClasses || ''}`"
    >
        This quote will expire on: <span> {{ format(props.expiryDate, "d MMMM yyyy") }}</span>
    </div>
</template>
